import { render } from "./PretsProgression.vue?vue&type=template&id=1f35ce2f"
import script from "./PretsProgression.vue?vue&type=script&lang=js"
export * from "./PretsProgression.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__